import { API } from '@/api/config';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useCompanyLimits = () => {
  return useQuery({
    queryKey: ['getCompanyLimits'],
    queryFn: async () => {
      return await API.get('/superadmin/company/limits/');
    },
  });
};

export const useCreateCompanyLimits = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (values) =>
      await API.post('/superadmin/company/limits/', values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getCompanyLimits'] });
    },
  });
};
